export const version = "strings/5.3.0";
//# sourceMappingURL=_version.js.map